import { useState, useContext } from "react";
import { FaRegCopy } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../styles/virtual.css";

const VirtualAccountPayment = () => {
  const { currentUser } = useContext(AuthContext);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => console.error("Failed to copy"));
  };

  return (
    <div className="pay-virtual-payment-container">
      <div className="select-virtual-card">
        <h6 className="virtual-header">Automated Bank Transfer Funding</h6>
        <p className="virtual-description">
          Make a transfer to your unique virtual account number below.
          Your wallet will be credited automatically and instantly after the transfer.
        </p>

        <div className="pay-virtual-card">
          <div className="pay-virtual-row">
            <span className="pay-virtual-label">ACCOUNT NO. (1.5% CHARGES)</span>
            <div className="pay-virtual-account-number">
              <div className="pay-account-number">{currentUser?.virtualAccountNo}</div>
              <button className="virtual-copy-btn" onClick={() => copyToClipboard(currentUser?.virtualAccountNo)}>
                <FaRegCopy />
              </button>
              {copied && <span className="virtual-copied-popup">Copied!</span>}
            </div>
          </div>

          <div className="pay-virtual-row">
            <span className="pay-virtual-label">BANK NAME</span>
            <p className="pay-virtual-value">Palmpay</p>
          </div>

          <div className="pay-virtual-row">
            <span className="pay-virtual-label">ACCOUNT NAME</span>
            <p className="pay-virtual-value">
              {currentUser?.virtualAccountName}
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default VirtualAccountPayment;
